import React from 'react';

export default function DayTab({ dayOfWeek, date, active, onClick }) {
  return (
    <button
      type="button"
      className={`portal-day-tab${active ? ' active' : ''}`}
      onClick={onClick}
    >
      <div className="portal-day-tab-dow">{dayOfWeek}</div>
      <div className="portal-day-tab-date">{date}</div>
    </button>
  );
}
